import React, { useContext } from 'react';
import { AskWellnessBuddy } from './AskWellnessBuddy';
import { useChatbotPrompt } from '../../hooks/useChatBotPrompt';
import { ChatBotContext } from '../../context/ChatBotContext';
import { getDistributionPrompts } from './prompts/userTrendPrompts';
import { useAuthStore } from '../../store/store';
import { useQuery } from '@tanstack/react-query';
import { getZScoresBarOption } from '../../data/chartOptions';
import { standardNormalData } from '../../data/chartData';
import { Line } from 'react-chartjs-2';
import { getZScoresByYearAndMonth } from '../../api/dashboard';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import annotationPlugin from 'chartjs-plugin-annotation';
import ClipLoader from 'react-spinners/ClipLoader';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    annotationPlugin,
);

const DistGraphsAllTime = ({ year, month }) => {
    const { updateChatBotPrompt } = useContext(ChatBotContext);

    const uid = useAuthStore(store => store.user?.uid);

    const zScoresQuery = useQuery({
        queryKey: ['zScoresByYearAndMonth', uid, year, month],
        queryFn: () => getZScoresByYearAndMonth(uid, year, month),
        enabled: (year !== '' && month !== '') && !(uid === null || uid === undefined),
    });

    const prompts = useChatbotPrompt(zScoresQuery, getDistributionPrompts(zScoresQuery));

    if (zScoresQuery.isLoading) {
        return (
            <div className='loading col-span-2'>
                <ClipLoader
                    loading={zScoresQuery.isLoading}
                    size={100}
                    aria-label='Loading Spinner'
                />
            </div>
        );
    }

    if (zScoresQuery.isError || zScoresQuery.data === null || zScoresQuery.data === undefined) {
        return (
            <div className='col-span-2 mt-3 text-center'>
                <p>You have not checked in yet. Please check in to view your mood and stress level summary.</p>
            </div>
        );
    }

    const graphData = [
        {
            scores: zScoresQuery.data.mood,
            prompt: prompts[0],
            title: 'Your Mood Z-Score Distribution',
        },
        {
            scores: zScoresQuery.data.stress,
            prompt: prompts[1],
            title: 'Your Stress Z-Score Distribution',
        },
        {
            scores: zScoresQuery.data.satisfaction,
            prompt: prompts[2],
            title: 'Your Satisfaction Z-Score Distribution',
        },
        {
            scores: zScoresQuery.data.tiredness,
            prompt: prompts[3],
            title: 'Your Tiredness Z-Score Distribution',
        },
    ];

    return (
        <>
            {
                graphData.map((data, index) => {
                    return (
                        <div className='flex flex-column items-center' key={index}>
                            <div className='min-h-[300px] w-full'>
                                <Line
                                    options={getZScoresBarOption(
                                        data.scores,
                                        data.title,
                                    )}
                                    data={standardNormalData}
                                />
                            </div>
                            <AskWellnessBuddy onClick={() => updateChatBotPrompt(data.prompt)}/>
                        </div>
                    );
                })
            }
        </>
    );
};

export default DistGraphsAllTime;
